export default "https://cdn-static.gokick.com/assets/29e4076df1e4180397d7539366c975103b08717a/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";